import { render, staticRenderFns } from "./OSelectLocations.vue?vue&type=template&id=4c084904"
import script from "./OSelectLocations.vue?vue&type=script&lang=js"
export * from "./OSelectLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports